<h2 mat-dialog-title>{{'LangDisplaySetting' | translate}}</h2>
<mat-dialog-content class="te-col-center" style="max-width: 100%">
    <mat-form-field appearance="fill" class="te-form-350">
        <mat-label>{{'AvailableLanguages'|translate}}</mat-label>
        <mat-select [(ngModel)]="languageCode">
            <mat-option *ngFor="let lang of languageOptions" [value]="lang.culture">{{ lang.cultureName }}</mat-option>
        </mat-select>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions style="align-self: flex-end; justify-content: flex-end;" class="te-row-full te-vert-spacer">
    <div class="te-form-350 te-row-end">
        <button mat-raised-button class="te-button-blue" (click)="updateLanguage()">{{'BtnSave' | translate}}</button>
        <button mat-raised-button class="te-button-gray te-left-spacer" mat-dialog-close>{{'BtnCancel' | translate}}</button>
    </div>
</mat-dialog-actions>